module.exports = __webpack_public_path__ + "static/media/MenuOpen.7a2dce74.svg";